import React from "react";
import { MRT_ToggleDensePaddingButton as WMRT_ToggleDensePaddingButton } from "material-react-table";

function MRT_ToggleDensePaddingButton(props) {
  return <WMRT_ToggleDensePaddingButton {...props} />;
}

export default MRT_ToggleDensePaddingButton;
